import React from 'react'

import { store } from '@Redux/store'
import { createRoot } from 'react-dom/client'
import './index.scss'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'

import { App } from './App'

const root = createRoot(document.getElementById('root') as Element)

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Provider store={store}>
        <App />
      </Provider>
    </BrowserRouter>
  </React.StrictMode>,
)
